import { Section, DataTable, Kpi, fmtDur, pctFmt } from "./_shared";

const DUR = ["avg_first_response_seconds", "median_first_response_seconds", "avg_response_seconds", "avg_resolution_seconds"];

export default function OmniResponse({ data }) {
  const t = data.totals || {};
  const fmt = { within_sla_pct: pctFmt, ...Object.fromEntries(DUR.map((k) => [k, fmtDur])) };
  const cols = (data.columns || []).map((c) => ({ ...c, label: c.label.replace(" (s)", "") }));
  const agentCols = cols.map((c) => (c.id === "name" ? { ...c, label: "Agent" } : c));
  return (
    <div className="space-y-4" data-testid="omni-response">
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3">
        <Kpi label="Conversations" value={t.conversations} testid="omni-rt-conv" />
        <Kpi label="Avg first response" value={fmtDur(t.avg_first_response_seconds)} testid="omni-rt-frt" />
        <Kpi label="Median first response" value={fmtDur(t.median_first_response_seconds)} testid="omni-rt-mfrt" />
        <Kpi label={`Within SLA (${fmtDur(data.sla_seconds)})`} value={`${t.within_sla_pct ?? 0}%`} testid="omni-rt-sla" />
        <Kpi label="Unanswered" value={t.unanswered} testid="omni-rt-unanswered" />
        <Kpi label="Avg resolution" value={fmtDur(t.avg_resolution_seconds)} hint={`${t.resolved ?? 0} resolved`} testid="omni-rt-res" />
      </div>
      <Section title="By channel" testid="omni-rt-channel-card">
        <DataTable columns={cols} rows={data.rows || []} format={fmt} testid="omni-rt-channel-table" />
      </Section>
      <Section title="By agent" testid="omni-rt-agent-card">
        <DataTable columns={agentCols} rows={data.agents || []} format={fmt} testid="omni-rt-agent-table"
          empty="No agent-handled conversations in this range." />
      </Section>
    </div>
  );
}
